import React, { FunctionComponent as FC, useState } from 'react';
import { GrantViewTypes } from '../../../../../types/data';
import _ from 'lodash';
import { themeColor } from '../../../../../types/style.global';
import { usR1Universities } from '../../../../../types/data.global';
import './index.scss';

import SideViewTooltipComponent from '../../SideViewTooltipComponent';
import { TooltipTypes } from '../../../../../types/data';

var numeral = require('numeral');

interface BarChartProps {
  chartTitle: string;
  data: GrantViewTypes.BarChartDataUnit[];
  width: number;
  height: number;
  heightWithLabel: number;
}

const BarChart: React.FC<BarChartProps> = (props) => {

    const { chartTitle, data, width, height, heightWithLabel } = props

    // 添加数据验证
    // console.log(`BarChart [${chartTitle}] received data:`, data);
    // console.log(`BarChart [${chartTitle}] data length:`, data?.length);

    // state variables
    const [showTooltip, setShowTooltip] = useState<boolean>(false)
    const [tooltipOpacity, setTooltipOpacity] = useState<number>(0)
    const [tooltipPosition, setTooltipPosition] = useState<TooltipTypes.TooltipPosition>({
        left: 0,
        top: 0,
    })
    const [tooltipData, setTooltipData] = useState<TooltipTypes.TooltipDataUnit[]>([{ " ": 0 }])


    // event handlers
    const handleBarChartMouseEnter = (event:  React.MouseEvent<HTMLDivElement>) => {
        // console.log('in handleBarChartMouseEnter')
        const idString = event.currentTarget.id;
        const [label, value] = idString.split('|');
        // 方括号内的表达式用于计算属性名
        // console.log('chartTitle', chartTitle)
        if(chartTitle === "Funder | subinstitution"){
            setTooltipData([{ [label]: "$ " + numeral(value).format('0,0') }])
        }
        else if(chartTitle === "University" || chartTitle ==="Science_field"){
            setTooltipData([{ [label]: " Number of PI:" + numeral(value).format('0') }])
        }
        else{
            setTooltipData([{ [label]: numeral(value).format('0') }])
        }
        setTooltipPosition({
            left: event.clientX + 24,
            top: event.clientY + 24,
        })
        setShowTooltip(true)
        setTooltipOpacity(1)
    }
    const handleBarChartMouseLeave = (event:  React.MouseEvent<HTMLDivElement>) => {
        setShowTooltip(false)
        setTooltipOpacity(0)
    }


    // visualization
    const k = 20; // top 20 个数据
    const p = 0.12; // 间距与bar的比例

    // 处理空数据或无效数据
    if (!data || data.length === 0) {
        return (
            <div className="bar-chart" style={{ width, height: heightWithLabel }}>
                <div className="bars-container">
                    <div style={{
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: '#999',
                        fontSize: '14px'
                    }}>
                        No data available
                    </div>
                </div>
            </div>
        );
    }

    // data应该是排好序的
    const topKData = data.slice(0, k);

    // 计算最大值，添加安全检查
    const maxValue = topKData.length > 0 ? Math.max(...topKData.map(item => Object.values(item)[0])) : 0;

    // console.log('topKData: ', typeof(topKData), topKData)
    // console.log('maxValue: ', maxValue)

    // 如果最大值为0或负数，显示空状态
    if (maxValue <= 0) {
        return (
            <div className="bar-chart" style={{ width, height: heightWithLabel }}>
                <div className="bars-container">
                    <div style={{
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: '#999',
                        fontSize: '14px'
                    }}>
                        No valid data
                    </div>
                </div>
            </div>
        );
    }

    // 计算每个 bar 的宽度和间距
    const totalBarWidth = width / k;
    const margin = p * totalBarWidth; // 计算 margin
    const barWidth = (1-p)*totalBarWidth; // 计算 bar 的宽度


    return (
        <div className="bar-chart" style={{ width, height: heightWithLabel }}>
        {/* <h3>{chartTitle}</h3> */}
        {chartTitle === "University" && (
                <div className="legend" style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-start",
                    alignItems: "center", /* 使得子元素在垂直方向上居中对齐 */
                    // justifyContent: space-around; /* 子元素之间平均分布空间，也可以根据需要改为其他值 */
                    width: "100%",
                    minHeight: "20px",
                    marginBottom: "8px"
                }}>
                    <div className="legend-item">
                        <span className="legend-color-r1"
                            style={{
                                background: themeColor.defaultMode.barChartBarColor,
                                width:"12px",
                                height: "12px",
                                display: "inline-block",
                                // marginTop: "2px",
                                marginRight: "8px"
                            }}>
                        </span>
                        <span className="legend-text">US R1 Univ.</span>
                    </div>
                    <div className="legend-item">
                        <span className="legend-color-others"
                            style={{
                                background: '#dad7cd',
                                width:"12px",
                                height: "12px",
                                display: "inline-block",
                                marginTop: "2px",
                                marginRight: "5px"
                         }}>
                         </span>
                        <span className="legend-text">Others</span>
                    </div>
                </div>
            )}
            <div className="bars-container">
                {topKData.map((item, index) => {
                    const label = Object.keys(item)[0];
                    const value = item[label];
                    const idString = `${label}|${value}`;
                    // 计算bar的高度
                    const barHeight = (value / maxValue) * height;

                    // console.log('barHeight: ', barHeight)
                    // console.log('value: ', value)
                    // console.log('maxValue: ', maxValue)
                    // console.log('height: ', height)
                    // console.log('\n\n')

                    // 计算 label 的长度
                    const labelLength = label.length * 8; // 假设每个字符宽度为 8px
                    // 是否显示 label
                    const showLabel = labelLength <= barHeight;

                    // 根据条件设置颜色
                    let barColor = themeColor.defaultMode.barChartBarColor
                    if (chartTitle === 'University' && (!usR1Universities[label])) {
                        barColor = '#dad7cd'
                    }
                    // const barColor = chartTitle === 'University' && usR1Universities[label] ? themeColor.defaultMode.barChartHighlightColor : themeColor.defaultMode.barChartBarColor;

                    return (
                        <div className="bar-wrapper" key={index} style={{ width: totalBarWidth }}>
                            {/* TODO: 这里之后要改成用themeColor */}
                            <div
                                className="bar"
                                id={idString}
                                style={{
                                    height: barHeight,
                                    width: barWidth,
                                    margin: `0 ${margin}px`,
                                    background: barColor,
                                    borderRadius: "1px 1px 0 0"
                                }}
                                onMouseEnter={(e) => handleBarChartMouseEnter(e)}
                                onMouseLeave={(e) => handleBarChartMouseLeave(e)}
                                >
                                {/* {showLabel && <span className="label">{label}</span>} */}
                            </div>
                        </div>
                    );
                })}
            </div>
            <SideViewTooltipComponent
                tooltipPosition={tooltipPosition}
                tooltipOpacity={tooltipOpacity}
                tooltipData={tooltipData}
            />
        </div>
    );
};

export default BarChart;